<div *ngIf="hideTabNav()" class="ui pointing secondary menu">
  <ng-container *ngFor="let tab of tabs">
    <a *ngIf="tab.isVisible" class="item" [class.active]="tab.selected" [class.disabled]="!tab.active" data-tab="tab.tabTitle" (click)="tab.active && onTabClick(tab)">{{tab.title}}</a>
  </ng-container>
</div>

<tab *ngFor="let tab of tabs" [configuration]="tab">
</tab>
